module.exports = __webpack_public_path__ + "img/電気回路_1_7_1.73eb8b63.jpeg";